import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { ClipboardList, CheckCircle, BarChart3, Star } from 'lucide-react';

interface SeedStatsCardsProps {
  timesAssigned: number;
  timesCompleted: number;
  completionRate: number;
  personalizedCount: number;
  avgDifficultyRating: number | null;
  sessionsByStatus: Record<string, number>;
}

export function SeedStatsCards({
  timesAssigned,
  timesCompleted,
  completionRate,
  personalizedCount,
  avgDifficultyRating,
  sessionsByStatus,
}: SeedStatsCardsProps) {
  const totalSessions =
    Object.values(sessionsByStatus).reduce((a, b) => a + b, 0);

  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Times Assigned</CardTitle>
          <ClipboardList className="h-4 w-4 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">{timesAssigned}</div>
          <p className="text-xs text-muted-foreground">
            {timesCompleted} completed
          </p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Completion Rate</CardTitle>
          <CheckCircle className="h-4 w-4 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">{completionRate}%</div>
          <p className="text-xs text-muted-foreground">
            of assignments completed
          </p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">AI Personalized</CardTitle>
          <BarChart3 className="h-4 w-4 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">{personalizedCount}</div>
          <p className="text-xs text-muted-foreground">
            {totalSessions} practice sessions
          </p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Avg Difficulty Rating</CardTitle>
          <Star className="h-4 w-4 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">
            {avgDifficultyRating != null ? avgDifficultyRating.toFixed(1) : '—'}
          </div>
          <p className="text-xs text-muted-foreground">
            rated by students
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
